import { useEffect, useState } from "react";
import styles from "./userAvatar.module.css";

// A user's photo, or — like the mobile app (Avatar.jsx) — the brand-gradient
// ring around a person outline when they have none, or when the photo fails
// to load. It fills its parent: the call site's wrapper sets the size and the
// shape (circle / rounded square), and the ring follows that shape.
const UserAvatar = ({ src, alt = "" }) => {
  const [failed, setFailed] = useState(false);

  // A new photo gets a fresh chance to load.
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt}
        className={styles.image}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className={styles.fallback} role="img" aria-label={alt}>
      <span className={styles.inner}>
        {/* The app's ProfileGlyph (Figma iconamoon:profile), 1.2 stroke on
            the 24pt artboard, at half the inner size. */}
        <svg
          className={styles.glyph}
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <g
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 18C4 16.94 4.42 15.92 5.17 15.17C5.92 14.42 6.94 14 8 14H16C17.06 14 18.08 14.42 18.83 15.17C19.58 15.92 20 16.94 20 18C20 18.53 19.79 19.04 19.41 19.41C19.04 19.79 18.53 20 18 20H6C5.47 20 4.96 19.79 4.59 19.41C4.21 19.04 4 18.53 4 18Z" />
            <path d="M12 10C13.66 10 15 8.66 15 7C15 5.34 13.66 4 12 4C10.34 4 9 5.34 9 7C9 8.66 10.34 10 12 10Z" />
          </g>
        </svg>
      </span>
    </span>
  );
};

export default UserAvatar;
